import { useFormikContext } from "formik";
import { GenericFormField, GenericFormSection } from "models/propTypes/genericFormProps";

function useCheckHasEditableField<T extends Record<string, any>>() {
  const { values } = useFormikContext<any>();

  const getHasEditableField = (item: GenericFormField<T> | GenericFormSection<T>, name?: string): boolean => {
    if (item.innerFields !== undefined) {
      const innerObj = Array.isArray(item.innerFields)
        ? (item.innerFields as any).map((innerField: GenericFormSection<T>) => getHasEditableField(innerField))
        : Object.entries(item.innerFields).map(
            ([key, innerField]) => innerField && getHasEditableField(innerField, key)
          );

      return innerObj.some((hasEditableField: boolean) => hasEditableField);
    } else {
      const field = item as GenericFormField<T>;
      if (field.readonly === undefined) {
        return false;
      } else if (field.readonly) {
        if (typeof field.readonly === "boolean") {
          return !field.readonly;
        } else {
          return !field.readonly(values);
        }
      } else {
        return true;
      }
    }
  };

  return {
    getHasEditableField,
  };
}

export default useCheckHasEditableField;
